<template>
  <div :id="`daily-menu-${item.id}`">
    <template v-if="item">
      <!-- Delivery time and address selector for guests -->
      <delivery-address-selector
        v-if="user.type === 'guest'"
        :delivery-from="deliveryFrom"
        :delivery-to="deliveryTo"
        :all-user-location="allUserLocations"
        :set-user-location="setUserLocation"
        :show-select="showSelect"
        :total="total"
        :item="item"
        :user-location="userLocation"
        :user_location="user_location"
        @setDeliveryTime="(idx) => $emit('setDeliveryTime', idx)"
        @changeAddress="(id, date) => $emit('changeAddress', id, date)"
        @showSelect="(val) => $emit('showSelect', val)"
      />
      <!-- Transferable location select -->
      <v-row justify="center" class="py-4" v-if="canChangeOffices">
        <v-col cols="12" md="4">
          <autocomplete
            v-model="item.location"
            :items="companies"
            item-text="name"
            return-object
            :label="$t('location')"
          />
        </v-col>
      </v-row>
      <!-- Shift meals columns -->
      <daily-menu-shift-meals :item="item" />
    </template>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import DeliveryAddressSelector from "./DeliveryAddressSelector.vue";
import DailyMenuShiftMeals from "./DailyMenuShiftMeals.vue";
import user from "@/store/user";

export default {
  name: "MenuDayCard",
  components: {
    DeliveryAddressSelector,
    DailyMenuShiftMeals,
  },
  props: {
    item: Object,
  },
  computed: {
    ...mapState("companyMenu", [
      "userLocation",
      "allUserLocations",
      "newUserLocation",
      "dialogs",
      "partners",
      "deliveryFrom",
      "deliveryTo",
      "showSelect",
      "total",
      "setUserLocation",
      "user_location",
    ]),
    canChangeOffices() {
      return this.$store.state.user.orderRules.canChangeOffices && this.company.parent_id;
    },
    user() {
      return this.$store.state.user.user || {};
    },
    company() {
      return this.$store.state.company;
    },
    companies() {
      return this.$store.state.companyMenu.companies || [];
    },
    restaurant() {
      return this.$store.state.restaurant || this.company.restaurant;
    },
  },
  methods: {
    ...mapMutations("companyMenu", ["setDialog", "setShowOrderDetails"]),
  },
};
</script>

<style scoped>
.datum {
  color: #000 !important;
  font-family: "Poppins", Helvetica, sans-serif !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  padding-left: 33vw;
  text-align: center;
  margin-top: 13px;
}
@media (max-width: 768px) {
  .dan-u-nedelji {
    font-size: 21px;
  }
}
.transfer-lista {
  width: 30%;
  margin: 0 auto;
}
</style>
